import { render, staticRenderFns } from "./PromoMembers.vue?vue&type=template&id=9b5ec3fe&scoped=true&lang=html&"
import script from "./PromoMembers.vue?vue&type=script&lang=js&"
export * from "./PromoMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5ec3fe",
  null
  
)

export default component.exports